import { useCallback, useMemo } from 'react';
import axios from 'axios';
import { API_PATH } from 'config';
import { getAccessTokenApi } from 'api/auth';

const authHeaders = () => ({ Authorization: getAccessTokenApi() });

const useImportExportApi = (config) => {
  const exportData = useCallback(
    async ({ scope, format }) => {
      const url = config.exportUrl(scope, format);
      const res = await axios.get(`${API_PATH}${url}`, {
        headers: authHeaders(),
        responseType: 'blob',
      });
      return res.data;
    },
    [config]
  );

  const validateImport = useCallback(
    async ({ file, scope }) => {
      const fd = new FormData();
      fd.append('file', file);
      fd.append('level', scope.level);
      if (scope.level === 'item') fd.append('itemId', scope.itemId);
      else fd.append('idColeccion', scope.idColeccion);
      const { data } = await axios.post(`${API_PATH}${config.validateUrl}`, fd, {
        headers: authHeaders(),
      });
      return data;
    },
    [config]
  );

  const commitImport = useCallback(
    async (payload) => {
      const { data } = await axios.post(`${API_PATH}${config.commitUrl}`, payload, {
        headers: authHeaders(),
      });
      return data;
    },
    [config]
  );

  return useMemo(
    () => ({ exportData, validateImport, commitImport }),
    [exportData, validateImport, commitImport]
  );
};

export default useImportExportApi;
